<header
  *ngIf="title"
  class="form-collapse__header"
  [ngClass]="{
    'form-collapse__header_background': displayHeaderBackground,
    'form-collapse__header_collapsible': collapsible,
    'form-collapse__header_opened': opened
  }"
  [style.--isp-form-collapse-title-font-size]="titleFontSize"
  [tabIndex]="0"
  (click)="toggleCollapse()"
  (keydown.space)="toggleCollapse()"
  (keydown.enter)="toggleCollapse($event)"
  [attr.role]="collapsible ? 'button' : ''"
  [attr.aria-expanded]="opened"
  [attr.aria-controls]="id"
  [attr.aria-label]="title"
  #header
>
  <isp-icon-provider
    *ngIf="collapsible"
    [nameOrUrl]="arrowIcon"
    [size]="'10px'"
    [inSprite]="true"
    class="form-collapse__arrow"
    data-ispui-tooltip-placement="topLeft"
    [attr.data-ispui-tooltip-text]="headerTooltip"
  ></isp-icon-provider>
  <isp-icon-provider
    *ngIf="icon"
    [nameOrUrl]="icon"
    [inSprite]="inSprite"
    [size]="'22px'"
    class="form-collapse__icon"
  ></isp-icon-provider>
  {{ title }}

  <isp-icon-provider
    *ngIf="displayRefresh"
    nameOrUrl="t-retry"
    role="button"
    [size]="'15px'"
    [inSprite]="true"
    [tabIndex]="0"
    class="form-collapse__icon-refresh"
    [class.form_collapse__icon-refresh_is-spinning]="isRefreshing"
    (click)="refreshContent($event)"
    (keyup.enter)="refreshContent($event)"
    (keyup.space)="refreshContent($event)"
    data-ispui-tooltip-placement="topRight"
    [attr.data-ispui-tooltip-text]="refreshTooltipMsg"
  ></isp-icon-provider>
</header>

<div
  [id]="id"
  class="form-collapse__content"
  [class.form-collapse__content_hidden]="!opened"
>
  <ng-content></ng-content>
</div>
